var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2C2C2C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.2,13.9c0.2,0.4,0.1,0.9-0.2,1.1l-0.1,0.1l-7.7,4.5L11,19.6c-0.2,0.2-0.5,0.3-0.9,0.3L10,20 c-0.4,0-0.7-0.1-1-0.4l-0.1-0.1l-7.7-4.5c-0.4-0.2-0.5-0.7-0.4-1.1l0-0.1c0.2-0.4,0.8-0.6,1.2-0.3l8,4.6l0,0l0,0l8-4.6 C18.4,13.3,18.9,13.5,19.2,13.9C19.2,13.9,19.2,13.9,19.2,13.9L19.2,13.9z M19.2,9.5c0.2,0.4,0.1,0.9-0.2,1.1l-0.1,0.1l-7.7,4.5 L11,15.3c-0.2,0.2-0.5,0.3-0.9,0.3l-0.2,0c-0.4,0-0.7-0.1-1-0.4l-0.1-0.1l-7.7-4.5C0.8,10.5,0.6,10,0.8,9.6l0-0.1 C1.1,9.1,1.6,8.9,2,9.2l8,4.6l0,0l0,0l8-4.6C18.4,8.9,18.9,9.1,19.2,9.5C19.2,9.5,19.2,9.5,19.2,9.5L19.2,9.5z M10,0 c0.4,0,0.7,0.1,1,0.3l0.1,0.1L19,4.3l0.1,0.1c0.6,0.7,0.6,1.8,0,2.5L19,7L11.1,11L11,11c-0.3,0.2-0.5,0.3-0.9,0.3l-0.2,0 c-0.4,0-0.7-0.1-1-0.3L8.9,11L1,7L0.9,6.9c-0.6-0.7-0.6-1.8,0-2.5L1,4.3l7.9-3.9L9,0.3C9.2,0.2,9.5,0,9.8,0L10,0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStake);
export default __webpack_public_path__ + "static/media/stake.633975c7.svg";
export { ForwardRef as ReactComponent };